import { Box, Text } from '@chakra-ui/react';

export const AlertsPreview = () => {
  return (
    <Box>
      <Text>AlertsPreview - Coming soon</Text>
    </Box>
  );
};
